export const getIsOverflowed = (element: HTMLDivElement | null) => {
  if (!element) {
    return false
  }

  const { clientHeight, clientWidth, scrollHeight, scrollWidth } = element

  return scrollHeight > clientHeight + 1 || scrollWidth > clientWidth + 1
}
